import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';
import UserService from "./services/UserService";

export const askForPermissioToReceiveNotifications = async () => {
  try {
    const messaging = firebase.messaging();
    await messaging.requestPermission();
    const token = await messaging.getToken();
    UserService.saveToken({ token });
    return token;
  } catch (error) {
    console.error(error);
  }
};

export const onReceiveNotifications = registration => {
  try {
    const messaging = firebase.messaging();
    messaging.onMessage(payload => {
      const notificationTitle = payload.data.title;
      const notificationOptions = {
        body: payload.data.body,
        icon: payload.data.icon,
        data: payload.data.business,
        actions: [
          {
            action: payload.data.click_action,
            title: payload.data.title
          }
        ]
      };
      registration.showNotification(notificationTitle, notificationOptions);
    });
  } catch (error) {
    console.error(error);
  }
};

export const initializeFirebase = () => {
  if (!firebase.apps.length) {
    let fireBaseConfig = {};
    if (process.env.REACT_APP_ENV === "prod") {
      fireBaseConfig = {
        apiKey: "AIzaSyA2DXc0yKCT2FHvvw-730FUB54N7f-MjAk",
        authDomain: "jkbaadshah2.firebaseapp.com",
        databaseURL: "https://jkbaadshah2.firebaseio.com",
        projectId: "jkbaadshah2",
        storageBucket: "jkbaadshah2.appspot.com",
        messagingSenderId: "145749868092",
        appId: "1:145749868092:web:6b43c648a2b974e983cd39",
        measurementId: "G-RYGDNKP0ZJ"
      };
    } else {
      fireBaseConfig = {
        apiKey: "AIzaSyBR8qIkGOlHz4Ipu42M15bh36FvZNa6kEY",
        authDomain: "jkbaadshah-test.firebaseapp.com",
        databaseURL: "https://jkbaadshah-test.firebaseio.com",
        projectId: "jkbaadshah-test",
        storageBucket: "jkbaadshah-test.appspot.com",
        messagingSenderId: "734673890915",
        appId: "1:734673890915:web:b3cfb66175bc9545961256",
        measurementId: "G-3QGZC43P42"
      };
    }
    firebase.initializeApp(fireBaseConfig);
  }

  if (firebase.messaging.isSupported()) {
    try {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("./firebase-messaging-sw.js", {
            updateViaCache: "none"
          })
          .then(registration => {
            firebase.messaging().useServiceWorker(registration);
            onReceiveNotifications(registration);
          });
      }
    } catch (error) {
      console.error(error);
    }
  }
};
